var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group"},_vm._l((_vm.options),function(option,index){return _c('div',{key:option.id,class:['radio-option',
                 {'active': _vm.isOptionActive(option),
                  'is-first': index === 0,
                  'is-last':  index === _vm.options.length - 1}],on:{"click":function($event){return _vm.setActiveOption(option)}}},[_c('div',[_c('span',[_vm._v(" "+_vm._s(option)+" ")])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }